var $ = global.jQuery = global.$;

var _Base = require('./_Base');

var ViewSwitch = _Base.extend({
  init: function() {
    var self = this;

    this.classes = {
      toggled: 'is-toggled'
    };

    this.$toggle = this.$el.find('[data-view-toggle]');
    this.$view = this.$el.find('[data-view]');

    this.isToggled = this.$view.hasClass(this.classes.toggled);

    this.$toggle.on('click', function(event) {
      event.preventDefault();
      self.toggle();
    });

  },

  toggle: function() {
    this.$view.toggleClass(this.classes.toggled);
    this.$toggle.toggleClass(this.classes.toggled);
  }
});

module.exports = ViewSwitch;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/ViewSwitch.js
 ** module id = 152
 ** module chunks = 0 1
 **/